"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataModel = void 0;
var Entity_1 = require("./Entity");
var SourceFile_1 = require("./SourceFile");
var DataModel = /** @class */ (function () {
    /**
     * This class is purely static and can not be constructed
     * @internal
     */
    function DataModel() {
        throw new Error("DataModel is purely static and can not be constructed");
    }
    /**
     * Get the data model for an entity
     * @param entity The entity's name
     * @returns The entity or null if not found
     */
    DataModel.for = function (entity) {
        var entityDef = SourceFile_1.get().sheet.find(function (e) { return e.name === entity; });
        return entityDef != null ? new Entity_1.Entity(entityDef) : null;
    };
    return DataModel;
}());
exports.DataModel = DataModel;
